<template>
    <div>
        <page-header></page-header>
        <!-- Heading and Filename -->
        <div>
            <table class="header-section">
                <tbody>
                    <tr>
                        <td style="width:30%;">
                            IMPORT TASKS (DRY RUN)
                        </td>
                        <td style="color: grey;">
                            {{ fileName }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <button class="back-button" @click="goBack">Back</button>
        <!-- Dry Run Information -->
        <div class="info-box">
            <span class="dryrun-span" title="dry run is a simulation where the database stays unaffected">Dry run</span>
            has
            been completed
            <li>Total records: {{ importedTasks.length }}</li>
            <li>Invalid records: {{ invalidTaskCount }}</li>
            <li>Valid tasks: {{ importedTasks.length - invalidTaskCount }}</li>
            <p></p>
            <li>Tasks added to the database: 0</li>
        </div>
        <div class="issuesDisplay">
            <div v-if="Object.keys(groupedIssues).length">
                <div v-for="(issues, index) in groupedIssues" :key="index" class="grey-line">
                    <!-- Display all issues for this index -->
                    <ul>
                        <br>
                        <li style="font-weight:bold">
                            Task (Row: {{ parseInt(this.ignoreFirstRow ? parseInt(index) + 2 : parseInt(index) + 1) }})
                        </li>
                        <ul>
                            <li style="font-weight:bold" v-for="(issue, issueIndex) in issues" :key="issueIndex">
                                {{ issue.message }}
                            </li>
                        </ul>
                    </ul>
                    <i style="color:grey; margin-left:20px;">Provided fields</i>
                    <div class="issue-list">
                        <!-- Check if there is an error in importedTasks -->
                        <ul
                            v-if="importedTasks[parseInt(this.ignoreFirstRow ? parseInt(index) + 1 : parseInt(index))] && importedTasks[parseInt(this.ignoreFirstRow ? parseInt(index) + 1 : parseInt(index))].error">
                            <li v-for="(field, fieldIndex) in importedTasks[parseInt(this.ignoreFirstRow ? parseInt(index) + 1 : parseInt(index))].row"
                                :key="fieldIndex">
                                {{ field }}
                            </li>
                        </ul>
                        <!-- If no error, display the regular fields -->
                        <ol v-else>
                            <li><strong>Chapter No: &nbsp;</strong> {{ importedTasks[parseInt(this.ignoreFirstRow ? parseInt(index) : index -1)]?.chapt_no || '' }}</li>
                            <li><strong>Task no: &nbsp;</strong> {{ importedTasks[parseInt(this.ignoreFirstRow ? parseInt(index) : index -1)]?.task_no || '' }}</li>
                            <li><strong>Logbook Entry: &nbsp;</strong> {{ importedTasks[parseInt(this.ignoreFirstRow ? parseInt(index) : index -1)]?.logbook_entry || '' }}</li>
                            <li><strong>Flight Deck: &nbsp;</strong> {{ importedTasks[parseInt(this.ignoreFirstRow ? parseInt(index) : index -1)]?.flight_deck || '' }}</li>
                            <li><strong>Observation: &nbsp;</strong> {{ importedTasks[parseInt(this.ignoreFirstRow ? parseInt(index) : index -1)]?.observation || '' }}</li>
                            <li><strong>Extra Info: &nbsp;</strong> {{ importedTasks[parseInt(this.ignoreFirstRow ? parseInt(index) : index -1)]?.extra_info || '' }}</li>
                            <li><strong>CMCS Fault: &nbsp;</strong> {{ importedTasks[parseInt(this.ignoreFirstRow ? parseInt(index) : index -1)]?.CMCS_fault || '' }}</li>
                            <li><strong>Questions: &nbsp;</strong> {{ importedTasks[parseInt(this.ignoreFirstRow ? parseInt(index) : index -1)]?.questions || '' }}</li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import pageHeader from '@/components/Examiner/Header.vue';

export default {
    data() {
        return {
            productId: parseInt(localStorage.getItem('product_id')),
            csvFileName: "",  // Initialized as an empty string
            entireFileRows: [],
            previewRows: [],
        };
    },
    components: {
        pageHeader,
    },
    computed: {
        issues() {
            return this.$store.state.issues;
        },
        importedTasks() {
            return this.$store.state.importedTasks;
        },
        invalidTaskCount() {
            const uniqueIssueTasks = new Set(this.issues.map(issue => issue.index));
            return uniqueIssueTasks.size;
        },
        groupedIssues() {
            return this.issues.reduce((acc, issue) => {
                // Adjust the index so it matches the actual position in importedTasks
                const adjustedIndex = this.ignoreFirstRow ? issue.index - 2 : issue.index - 1;

                if (!acc[issue.index]) {
                    acc[issue.index] = [];
                }

                // Attach adjustedIndex for later use in the template if needed
                issue._adjustedIndex = adjustedIndex;

                acc[issue.index].push(issue);
                return acc;
            }, {});
        },
        fileName() {
            return this.$store.state.fileName;
        },
        ignoreFirstRow() {
            return this.$store.state.ignoreFirstRow;
        }
    },
    methods: {
        goBack() {
            this.$router.push({ name: 'ImportAssessmentTasks' });
        },
    },
    mounted() {
        console.log("importedTasks:", this.importedTasks);
        console.log("issues from Vuex:", this.$store.state.issues);
        console.log("ignore first row:", this.$store.state.ignoreFirstRow);
    }
}
</script>



<style scoped>
.grey-line {
    border-top: 1px solid rgb(179, 179, 179);
    /* Add a grey border on the top to create the line effect */
    margin-top: 10px;
    /* Adjust the margin as needed */
    margin-bottom: 10px;
    /* Adjust the margin as needed */
    max-width: 100%;
}

.header-section {
    width: 99%;
    text-align: left;
    height: 90%;
    margin-left: 1%;
}

.header-section td {
    font-size: 28px;
}

.info-box {
    border: 1px solid #ecb1b1;
    padding: 20px;
    margin: 0px 20px;
    color: #ca3f4b;
    font-weight: bold;
    background-color: #F8D7DA;
    width: 60%;
    height: 180px;
    text-align: left;
}

.issuesDisplay {
    text-align: left;
    margin-top: 20px;
}

.issue-list {
    margin-left: 1%;
    background-color: rgb(250, 248, 248);
    width: 98%;
}

.dryrun-span {
    border: none;
}

.back-button {
    position: absolute;
    /* Adjust the top position as needed */
    right: 60px;
    /* Adjust the right position as needed */
    width: 100px;
    border-radius: 5px;
    background-color: #c1e0bf;
    font-size: 14px;
    border: 2px solid black;
    padding: 3px;
}

.back-button:hover {
    background-color: #abc7a9;
    cursor: pointer;
}
</style>